import {Component, ElementRef, OnInit, ViewChild, AfterViewInit, OnDestroy} from '@angular/core';
import {BehaviorSubject, of, zip} from 'rxjs';
import {BestellungService} from 'services/bestellung/bestellung.service';
import {DialogService} from 'services/prozesse/dialog.service';
import {KundeService} from 'services/kunden/kunde.service';
import {MandantenService} from 'services/mandanten/mandanten.service';
import {NavigationEnd, Router} from '@angular/router';
import {map} from 'rxjs/operators';
import {MitteilungsService} from 'services/prozesse/mitteilung.service';
import {MatDialog} from '@angular/material/dialog';
import {StateService} from '../../../../services/app/state.service';
import {BenachrichtigungService} from '../../../../services/prozesse/benachrichtigung.service';
import {FaqService} from '../../../../module/obs.shared/componenten/faq/faq.service';
import {FlexLinkService} from '../../../../services/navigation/flexLink.service';

@Component({
  selector: 'wbpFooter',
  templateUrl: './wbpFooter.component.html',
  styleUrls: ['./wbpFooter.component.css'],
})


export class WbpFooterComponent implements OnInit, AfterViewInit, OnDestroy {

  constructor(
    public dialog_service: DialogService,
    public mandant_service: MandantenService,
    public state_service: StateService,
    public kunde_service: KundeService,
    public mitteilungsService: MitteilungsService,
    private benachrichtigung_service: BenachrichtigungService,
    private router: Router,
    public faq_service: FaqService,
    public flexLink: FlexLinkService,
  ) {
  }

  @ViewChild('web-menu-tiles') tiles: ElementRef;
  public mandant: any
  public kunde: object | boolean
  public data = new BehaviorSubject<any>(false)
  public item: string
  public message: any
  public rechts_content: any
  public content: string
  public flag: any
  public kuendigung
  public faq
  public seite

  private subscription

  ngOnInit() {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd){
        this.seite = decodeURIComponent(this.router.url.split('=')[1])
      }
    })
    this.dialog_service.routes_observer(() => {
      this.get()
    })
    this.get()
    this.getRechtliches()
  }

  ngAfterViewInit() {
    zip(

      this.kunde_service._kunde_get(),
      this.mitteilungsService.benachrichtigungen
    ).subscribe((response) => {
      this.kunde = response[0]
      if (this.kunde != undefined) {
        this.benachrichtigung_service.setze_benachrichtigungen(this.kunde)
      }
      this.flag = response[1]
      this.faq_service.faqAnzeigen(this.kunde)
      this.faq_service.faqAnzeige.subscribe(anzeige => {
        this.faq = anzeige
      })
    })
  }

  ngOnDestroy() {
    this.subscription.unsubscribe()
  }

  public get() {
    zip(
      this.mandant_service.mandant_get(),
      this.kunde_service._kunde_get()
    ).subscribe((result: any) => {
      this.kuendigung = result[0].sonderKonfiguration.API_1_5.terminateContractURL
      this.mandant = result[0]
      this.kunde = result[1]
      this.data.next({
        mandant: result[0],
        kunde: result[1]
      })
    })
  }

  public getRechtliches() {
    this.subscription = this.state_service.mandant
      .pipe(map((mandant) => {
        return <any>mandant
      }))
      .subscribe((mandant) => {
        this.rechts_content = [
          {content: mandant.betreiberDaten.agb, name: 'AGB'},
          {content: mandant.betreiberDaten.datenschutz, name: 'Datenschutz'},
          {content: mandant.betreiberDaten.widerruf, name: 'Widerruf'},
          {content: mandant.betreiberDaten.impressum, name: 'Impressum'},
          {name: 'Kontakt'}
        ]
      })
  }
}

